import React, { useRef, useState } from "react";
import { Navbar, Nav, Container, OverlayTrigger } from "react-bootstrap";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Style from "./DesktopHeader.module.css";
import { Logo } from "../../constant/imagePath";
import LoginModal from "../../modals/LoginModal/LoginModal";
import SignUpModal from "../../modals/SignUpModal/SignUpModal";
import { IoLogInOutline } from "react-icons/io5";
import { FaSortDown } from "react-icons/fa6";
import { MdCall } from "react-icons/md";
import { apiUrl, imageUrl } from "../../config/apiUrl";
import { signOutRequest } from "../../store/auth/authSlice";
import { io } from "socket.io-client";
import LogoutModal from "../../modals/LogoutModal";
import NavbarItemDesktop from "./NavbarItemDesktop";
import { useLogo } from "../../contexts/LogoContext";

const navbarData = [
  {
    label: 'home',
    path: 'https://denverbbs.com/',
  },
  {
    label: 'listings',
    path: '/buy-a-business',
  },
  // {
  //   label: 'sell my business',
  //   path: 'https://denverbbs.com/sell-my-business/',
  // },
  // {
  //   label: 'about us',
  //   path: 'https://denverbbs.com/about-us/',
  //   sublists: [
  //     {
  //       label: 'our teams',
  //       path: 'https://denverbbs.com/our-team/',
  //     }
  //   ]
  // },
  // {
  //   label: 'careers',
  //   path: 'https://denverbbs.com/career-opportunities/',
  // },
  // {
  //   label: 'blog',
  //   path: 'https://denverbbs.com/blog/',
  // },
  // {
  //   label: 'contact us',
  //   path: 'https://denverbbs.com/contact-us/',
  // },
]

const DesktopHeader = ({
  tempLogo = Logo,
  backgroundColor,
  containerClass,
  className,
}) => {
  const storedPhone = localStorage.getItem('frontend_companyPhone');
  const storedWebsite = localStorage.getItem('frontend_companyWebsite');
  const { logo } = useLogo();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [openLogin, setOpenLogin] = useState(false);
  const [openSignUp, setOpenSignUp] = useState(false);
  const [openLogout, setOpenLogout] = useState(false);
  const [show, setShow] = useState(false);
  const { isLogin, user, fcmToken } = useSelector(
    (state) => state?.authReducer
  );

  console.log('>>>>>>>>>> user => ', user)

  const socket = useRef(null);

  const logout = () => {
    socket.current = io(apiUrl);
    socket.current.emit("logout", { _id: user?._id, fcmToken });
    dispatch(signOutRequest());
    navigate("/");
  };

  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      className={`${[Style.header, className].join(" ")}`}
      style={{ backgroundColor: backgroundColor }}
      id={"navDesktopHeader"}
    >
      <Container
        className={`${[Style.navbarAnnouncement].join(" ")}`}
      >
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
            <p
              className={Style.header_right}
              style={{ cursor: "text" }}
            >
              Need Guidance?
            </p>
            <a href={`tel:${storedPhone?.replace(/-/g, '')}`} className={Style.header_right} style={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {storedPhone}{" "}
              <MdCall
                className={[Style.headerIconSize]}
                color={"var(--white-color)"}
              />
            </a>
          </div>

          {isLogin ? (
            <>
              <div style={{ display: 'flex', gap: '20px' }}>
                <p className={[Style.header_right]} onClick={() => { setOpenLogout(true); }}>
                  Logout
                </p>
                <NavLink
                  to="/dashboard"
                  className={[Style.header_right]}
                >
                  DASHBOARD
                </NavLink>

                <NavLink to="/update-profile">
                  <div className={[Style.profileImg]}>
                    <img src={`${imageUrl}${user?.photo}`} alt="..." />
                  </div>
                </NavLink>
              </div>
            </>
          ) : (
            <div>
              <p
                className={Style.header_right}
                onClick={() => setOpenLogin(true)}
              >
                CLIENT LOGIN{" "}
                <IoLogInOutline
                  className={[Style.headerIconSize]}
                  color={"var(--white-color)"}
                />
              </p>
            </div>
          )}
        </div>
      </Container>
      <Container
        className={`${[Style.navbarContainer, containerClass].join(" ")}`}
      >
        <NavLink to={`https://${storedWebsite}/`}>
          <div className={Style.main_logo_main} >
            <img src={`${imageUrl}${logo}`} alt="logo" />
          </div>
        </NavLink>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className={`mx-auto ${[Style.gapCustm].join(" ")}`}>
            <>
              {/* <NavLink
                to="/buy-a-business"
                className={({ isActive }) =>
                  isActive
                    ? `${[Style.nabarLinks, Style.navActive].join(" ")}`
                    : `${[Style.nabarLinks]}`
                }
              >
                Buy a Business
              </NavLink> */}
              {
                navbarData.map((_navbarItem, index) => {
                  const navItem = {
                    ..._navbarItem,
                    path: _navbarItem.path.replace('denverbbs.com', storedWebsite)
                  };
                  return <NavbarItemDesktop
                    key={`navbar-item-${index}`}
                    {...navItem}
                    isActive={location.pathname === navItem.path}
                  />;
                })
              }
            </>
          </Nav>
        </Navbar.Collapse>
      </Container>

      {openLogin && (
        <LoginModal
          show={openLogin}
          setShow={setOpenLogin}
          showSignUp={setOpenSignUp}
        />
      )}

      {openSignUp && (
        <SignUpModal
          showLogin={setOpenLogin}
          show={openSignUp}
          setShow={setOpenSignUp}
        />
      )}

      {openLogout && (
        <LogoutModal
          show={openLogout}
          setShow={setOpenLogout}
          logout={logout}
        />
      )}
    </Navbar>
  );
};

export default DesktopHeader;
